import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_my-vitreo-preview/artifacts/mslzw0uv_MY%20VITREO.png";

const navLinks = [
  { name: "Accueil", path: "/" },
  { name: "Services", path: "/services" },
  { name: "À propos", path: "/a-propos" },
  { name: "Rendez-vous", path: "/rendez-vous" },
  { name: "Devis", path: "/devis" },
  { name: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="glass-nav fixed top-0 left-0 right-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 sm:h-28 lg:h-28">
          {/* Logo - Much larger for mobile/tablet */}
          <Link to="/" className="flex items-center flex-shrink-0" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="MY VITREO - La solution vitrage de confiance" 
              className="h-14 sm:h-24 md:h-28 lg:h-24 w-auto max-w-[180px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-[280px] object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.path.replace("/", "") || "home"}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                  location.pathname === link.path
                    ? "bg-sky-500 text-white"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:0695442788"
              className="flex items-center gap-2 text-slate-300 hover:text-sky-400 transition-colors"
              data-testid="phone-link"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">06 95 44 27 88</span>
            </a>
            <Link to="/rendez-vous">
              <Button className="bg-sky-500 hover:bg-sky-600 text-white rounded-full px-6" data-testid="cta-rdv-nav">
                Prendre RDV
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-slate-800 text-white transition-colors"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden glass-card border-t border-white/20" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-xl text-base font-medium transition-colors ${
                  location.pathname === link.path
                    ? "bg-sky-500 text-white"
                    : "text-slate-300 hover:bg-slate-800"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-slate-700">
              <a
                href="tel:0695442788"
                className="flex items-center justify-center gap-2 w-full py-3 bg-sky-500 text-white rounded-full font-medium"
              >
                <Phone className="w-5 h-5" />
                06 95 44 27 88
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
